<template>
	<div class="fullpage-iframe">
		<iframe
			v-if="iframeSrc"
			:src="iframeSrc"
			sandbox="allow-same-origin allow-scripts allow-forms"
			width="100%"
			height="100%"
			frameborder="0"
		></iframe>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const iframeSrc = computed(() => props.fields?.iframeSrc?.value);
</script>

<style lang="scss">
.fullpage-iframe {
	height: 100%;

	iframe {
		position: absolute;
		top: var(--header-height, 100px);
		left: 0;
		bottom: 0;
		right: 0;
	}
}
</style>
